import { useEffect, useState } from 'react'
// import { useLocation } from 'react-router-dom'
import { getI18n, useTranslation } from 'react-i18next'
import { loadModuleTranslations } from '../utils/translations'
import modules from '../constants/modules'
import { useAuth } from '@erpsquad/common/runtime'
import { Pathname } from '../constants'

// Global state to prevent duplicate calls across all hook instances
let globalLastLoadedModules = ''
let globalIsLoading = false
let globalInitialLoad = false

export const useAppTranslations = () => {
	const [isLoading, setIsLoading] = useState(globalInitialLoad)
	const location = window.location
	const i18nInstance = getI18n()
	const { user, loading } = useAuth()
	const { t } = useTranslation()

	useEffect(() => {
		const erpModules = modules(t)
		const currentPath = location.pathname.toLowerCase()
		if(user?.id && !loading) {
	
			const matchedModule = erpModules.find(
				(mod) =>
					mod.link.toLowerCase() === currentPath ||
					mod.connectedRoutes?.some((route: string) => currentPath.startsWith(route.toLowerCase()))
			)
	
			let modulesToLoad: string[] = []
	
			if (matchedModule?.translationModule) {
				modulesToLoad = [...matchedModule.translationModule, 'common']
			} else if (!matchedModule && (currentPath === Pathname.DASHBOARD || currentPath === Pathname.LANDING_PAGE)) {
				modulesToLoad = ['common']
			}
	
			if (modulesToLoad.length > 0) {
				const moduleKey = [...modulesToLoad].sort().join(',')
	
				// Skip if same modules are already loaded or currently loading
				if (globalLastLoadedModules === moduleKey || globalIsLoading) {
					if (globalInitialLoad) {
						setIsLoading(false)
						globalInitialLoad = false
					}
					return
				}
	
				globalIsLoading = true
				globalLastLoadedModules = moduleKey
				setIsLoading(true)
	
				loadModuleTranslations(modulesToLoad, i18nInstance).finally(() => {
					globalIsLoading = false
					setIsLoading(false)
					globalInitialLoad = false
				})
			} else {
				// No modules to load, but still need to handle initial load state
				if (globalInitialLoad) {
					setIsLoading(false)
					globalInitialLoad = false
				}
			}
		}
	}, [location.pathname, t, user, loading])

	return { isLoading }
};

export default useAppTranslations;
export { useTranslation } from 'react-i18next';
